import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.checklist.facilities');
import { OnInit, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let WizRoute: any;
declare let wiz: any;

@Component({
    selector: 'wiz-page-checklist-facilities',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.checklist.facilities/view.scss */
:host {
  display: block;
  height: 100vh;
  background-color: #F8F9FA;
}

.facilities-page {
  font-family: "Pretendard", sans-serif;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.header-container {
  background-color: #FFFFFF;
  padding: 12px 20px;
  border-bottom: 1px solid #E3E3E3;
  z-index: 10;
  flex-shrink: 0;
}

.top-app-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
.top-app-bar .nav-btn {
  width: 44px;
  height: 44px;
  border-radius: 22px;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #444746;
  cursor: pointer;
  flex-shrink: 0;
}
.top-app-bar .nav-btn:hover {
  background-color: #F1F3F4;
}
.top-app-bar .nav-btn i {
  font-size: 18px;
}

.header-title-row {
  flex: 1;
}
.header-title-row .header-title {
  font-size: 18px;
  font-weight: 800;
  color: #1F1F1F;
  margin: 0;
}
.header-title-row .header-subtitle {
  font-size: 13px;
  color: #70757A;
  font-weight: 500;
}

.search-group {
  display: flex;
  align-items: center;
  background-color: #F1F3F4;
  height: 40px;
  border-radius: 20px;
  padding: 0 16px;
  gap: 10px;
  width: 100%;
  max-width: 260px;
  transition: all 0.2s;
  border: 1px solid transparent;
}
.search-group:focus-within {
  background-color: #FFFFFF;
  border-color: #0B57D0;
}
.search-group .search-icon {
  color: #5F6368;
  font-size: 14px;
}
.search-group input {
  width: 100%;
  background: transparent;
  border: none;
  outline: none;
  font-size: 14px;
  color: #1F1F1F;
  font-weight: 500;
}
.search-group input::placeholder {
  color: #70757A;
}

.scaffold-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 16px 20px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.facility-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.facility-card {
  background-color: #FFFFFF;
  border-radius: 16px;
  border: 1px solid #E8EAED;
  overflow: hidden;
  transition: all 0.2s ease;
}
.facility-card:hover {
  border-color: #D3E3FD;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.facility-card.selected {
  border-color: #0B57D0;
  box-shadow: 0 2px 12px rgba(11, 87, 208, 0.12);
}
.facility-card.no-checklist {
  opacity: 0.6;
}

.facility-main {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  cursor: pointer;
  transition: background-color 0.15s;
}
.facility-main:hover {
  background-color: #F8F9FA;
}

.facility-icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background-color: #E8F0FE;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.facility-icon i {
  font-size: 20px;
  color: #0B57D0;
}

.facility-info {
  flex: 1;
  min-width: 0;
}

.facility-name {
  font-size: 15px;
  font-weight: 700;
  color: #1F1F1F;
  margin: 0 0 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.facility-desc {
  font-size: 12px;
  color: #5F6368;
  margin: 0 0 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.facility-meta {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.meta-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  background-color: #F1F3F4;
  color: #5F6368;
}
.meta-badge i {
  font-size: 10px;
}
.meta-badge.checklist-badge {
  background-color: #FEF7E0;
  color: #B05E00;
}
.meta-badge.has-checklist {
  background-color: #E6F4EA;
  color: #137333;
}

.facility-arrow {
  flex-shrink: 0;
}
.facility-arrow i {
  font-size: 14px;
  color: #9AA0A6;
  transition: transform 0.3s;
}
.facility-arrow i.rotated {
  transform: rotate(180deg);
}

.checklist-panel {
  border-top: 1px solid #E8EAED;
  padding: 8px 12px;
  background-color: #FAFBFC;
}

.checklist-empty {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 8px;
  font-size: 13px;
  color: #9AA0A6;
}
.checklist-empty i {
  font-size: 14px;
}

.checklist-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.15s;
}
.checklist-item:hover {
  background-color: #E8F0FE;
}
.checklist-item:active {
  transform: scale(0.99);
}

.cl-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.cl-icon.inspection {
  background-color: #E8F0FE;
}
.cl-icon.inspection i {
  color: #1A73E8;
}
.cl-icon.sports {
  background-color: #E6F4EA;
}
.cl-icon.sports i {
  color: #1E8E3E;
}
.cl-icon.generic {
  background-color: #F1F3F4;
}
.cl-icon.generic i {
  color: #5F6368;
}
.cl-icon i {
  font-size: 16px;
}

.cl-info {
  flex: 1;
  min-width: 0;
}

.cl-title {
  font-size: 14px;
  font-weight: 700;
  color: #1F1F1F;
  margin: 0 0 4px;
}

.cl-tags {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.cl-tag {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
}
.cl-tag.inspection {
  background-color: #D3E3FD;
  color: #041E49;
}
.cl-tag.sports {
  background-color: #CEEAD6;
  color: #0D652D;
}
.cl-tag.generic {
  background-color: #E8EAED;
  color: #3C4043;
}
.cl-tag.category {
  background-color: #F1F3F4;
  color: #5F6368;
}

.cl-action {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
  flex-shrink: 0;
}
.cl-action i {
  font-size: 11px;
}
.cl-action .status-label.submitted {
  color: #137333;
}
.cl-action .status-label.submit-pending {
  color: #1A73E8;
}
.cl-action .status-label.sync-failed {
  color: #C5221F;
}
.cl-action .status-label.draft {
  color: #B05E00;
}
.cl-action .status-label.new {
  color: #0B57D0;
}
.cl-action i.fa-check-circle {
  color: #137333;
}
.cl-action i.fa-clock {
  color: #1A73E8;
}
.cl-action i.fa-triangle-exclamation {
  color: #C5221F;
}
.cl-action i.fa-pencil {
  color: #B05E00;
}
.cl-action i.fa-arrow-right {
  color: #0B57D0;
}

.loader-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.loader-container p {
  margin-top: 16px;
  font-size: 14px;
  color: #5F6368;
  font-weight: 600;
}

.google-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #E8EAED;
  border-top-color: #0B57D0;
  border-radius: 50%;
  animation: spin 0.9s ease-in-out infinite;
}

.empty-view {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.empty-view .empty-icon {
  width: 80px;
  height: 80px;
  margin-bottom: 16px;
  background: #F1F3F4;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.empty-view .empty-icon i {
  font-size: 32px;
  color: #9AA0A6;
}
.empty-view h3 {
  font-size: 18px;
  color: #3C4043;
  font-weight: 700;
  margin: 0 0 6px;
}
.empty-view p {
  font-size: 13px;
  color: #5F6368;
  margin: 0;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}`],
})
export class PageChecklistFacilitiesComponent implements OnInit {
    public project: any = null;
    public facilities: any[] = [];
    public loading: boolean = true;
    public searchText: string = '';
    public projectId: string = '';

    /** 선택된 시설물 (체크리스트 목록 표시용) */
    public selectedFacility: any = null;

    constructor(@Inject( Service)         public service: Service,@Inject( CDR    )         public ref: CDR    ) { }

    public async ngOnInit() {
        await this.service.init(this);
        this.projectId = WizRoute.segment.projectId || '';

        if (!this.projectId) {
            await this.service.href('/checklist');
            return;
        }

        await this.loadFacilities();
    }

    public async loadFacilities() {
        this.loading = true;
        await this.service.render();

        try {
            const { code, data } = await wiz.call("load", { project_id: this.projectId }, { timeout: 120000, forceServer: true });
            if (code === 200) {
                this.project = data.project;
                this.facilities = data.facilities || [];
            }
        } catch (e) {
            console.error(e);
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public get filteredFacilities(): any[] {
        if (!this.searchText) return this.facilities;
        const q = this.searchText.toLowerCase().trim();
        return this.facilities.filter(f =>
            f.name.toLowerCase().includes(q) ||
            (f.description && f.description.toLowerCase().includes(q))
        );
    }

    public selectFacility(facility: any) {
        if (this.selectedFacility && this.selectedFacility.id === facility.id) {
            this.selectedFacility = null;
        } else {
            this.selectedFacility = facility;
        }
        this.service.render();
    }

    public async startChecklist(mapping: any) {
        // 이미 제출되었거나 제출 동기화 중인 체크리스트면 결과 페이지로 이동
        if ((mapping.response_status === 'submitted' || mapping.response_status === 'submit_pending') && mapping.response_id) {
            await this.service.href(`/checklist/result/${mapping.response_id}`);
            return;
        }

        // 이미 작성 중인 draft가 있으면 바로 이동
        if (mapping.response_status === 'draft' && mapping.response_id) {
            await this.service.href(`/checklist/respond/${mapping.response_id}`);
            return;
        }

        // 새 응답 생성
        await this.service.loading.show();
        try {
            const { code, data } = await wiz.call("start_checklist", {
                mapping_id: mapping.mapping_id
            }, { timeout: 60000 });
            if (code === 200 && data.response_id) {
                if (data.status === 'submitted' || data.status === 'submit_pending') {
                    await this.service.href(`/checklist/result/${data.response_id}`);
                } else {
                    await this.service.href(`/checklist/respond/${data.response_id}`);
                }
            }
        } catch (e) {
            console.error(e);
            await this.service.alert.show({
                title: '오류',
                message: '체크리스트를 시작할 수 없습니다.',
                action: '확인',
                cancel: false
            });
        } finally {
            await this.service.loading.hide();
        }
    }

    public getFormTypeLabel(formType: string): string {
        if (formType === 'inspection') return '정기안전점검';
        if (formType === 'sports') return '체육시설점검';
        return '일반 체크리스트';
    }

    public getFormTypeColor(formType: string): string {
        if (formType === 'inspection') return 'inspection';
        if (formType === 'sports') return 'sports';
        return 'generic';
    }

    public getStatusLabel(status: string): string {
        if (status === 'submitted') return '제출 완료';
        if (status === 'submit_pending') return '제출 동기화 대기';
        if (status === 'sync_failed') return '동기화 실패';
        if (status === 'draft') return '작성 중';
        return '점검 시작';
    }

    public getStatusClass(status: string): string {
        if (status === 'submitted') return 'submitted';
        if (status === 'submit_pending') return 'submit-pending';
        if (status === 'sync_failed') return 'sync-failed';
        if (status === 'draft') return 'draft';
        return 'new';
    }

    public getStatusIcon(status: string): string {
        if (status === 'submitted') return 'fa-solid fa-check-circle';
        if (status === 'submit_pending') return 'fa-solid fa-clock';
        if (status === 'sync_failed') return 'fa-solid fa-triangle-exclamation';
        if (status === 'draft') return 'fa-solid fa-pencil';
        return 'fa-solid fa-arrow-right';
    }

    public async goBack() {
        await this.service.href('/checklist');
    }
}

export default PageChecklistFacilitiesComponent;